import { FormControl, MenuItem, Select, OutlinedInput, InputAdornment, InputLabel, Stack } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import useMediaQueries from "utils/mediaQueries.utils";

const menuProps = {
  PaperProps: {
    style: {
      maxHeight: 200,
      marginTop: "1rem",
    },
  },
};

const StateSelector = ({ listOfStates, destinationUrl }) => {
  const { isLg } = useMediaQueries();
  const [currentState, setCurrentState] = useState("");
  const navigate = useNavigate();
  const handleChange = (event) => {
    setCurrentState(event.target.value);
  };

  const handleExploreOptions = () => {
    navigate(`${destinationUrl}${currentState.toLowerCase()}`);
  };

  return (
    <Stack role="region" aria-label="State selection" spacing={2} direction={isLg ? "row" : "column"} alignItems="center">
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="state-select-label">Select Your State</InputLabel>
        <Select
          labelId="state-select-label"
          id="state-select"
          value={currentState}
          onChange={handleChange}
          displayEmpty
          label="Select your state"
          input={
            <OutlinedInput
              id="state-select-input"
              label="Select your state"
              endAdornment={
                <InputAdornment position="end">
                  <ExpandMoreIcon aria-hidden="true" role="presentation" sx={{ zIndex: "-1" }} />
                </InputAdornment>
              }
            />
          }
          MenuProps={{
            ...menuProps,
            PaperProps: {
              ...menuProps.PaperProps,
              "aria-label": "State selection options",
              role: "listbox",
            },
          }}
          sx={{
            "& .MuiInputBase-input": {
              color: "black !important",
              height: "44px",
              display: "flex",
              alignItems: "center",
              padding: "10px 14px",
              marginRight: "-40px",
            },
            "& .MuiFormLabel-root": {
              color: "black !important",
            },
            height: "44px",
            width: "100%",
          }}
        >
          {listOfStates.map((state) => (
            <MenuItem key={state} value={state} role="option" aria-selected={currentState === state}>
              {state}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {currentState && (
        <MKBox sx={{ width: "100%" }}>
          <MKButton variant="contained" color="secondary" onClick={handleExploreOptions} aria-label={`Explore therapy options for ${currentState}`}>
            Explore Options for {currentState}
          </MKButton>
        </MKBox>
      )}
    </Stack>
  );
};

export default StateSelector;
